// extracted by mini-css-extract-plugin
export default {"animation":"animation__PSTro","fadeInAnimation":"fadeInAnimation__xQQ1v","heading":"heading__ENjtG","textArea":"textArea__alDlG","submitButton":"submitButton__E5iq4"};